import {LitElement} from 'lit';
import {html} from 'lit/html.js';

import css from './tt-wappen.pcss';

import '@polymer/iron-image'

export default class TTWappen extends LitElement {
    static get properties() {
        return {
            team: {
                type: String,
            },
            size: {
                type: String,
            }
        };
    }

    static get styles() {
        return [css];
    }


    render() {
        return html`
<iron-image sizing="contain" src=${this.getImage(this.team, this.size)} preload placeholder=${this.getPlaceholder()}>
</iron-image>
`;
    }

    getPlaceholder() {
        return `${SOURCE.publicPath}assets/bannerplaceholder.png`;
    }

    getImage(team, size) {
        if (team) {
            const replaced = team.toLowerCase()
                    .replace(/\d/g, "")
                    .replace(/ +/g, "-")
                    .replace(/\//g, "-")
                    .replace(/ö/g, "oe")
                    .replace(/ü/g, "ue")
                    .replace(/ä/g, "ae")
                    .replace(/ß/g, "ss")
                    .replace(/\./g, "")
                    .replace(/^\-/, "")
                    .replace(/\-$/, "")
                + ".png";

            const folder = (size) ? size + "/" : "";

            return `${SOURCE.publicPath}assets/logo/${folder}${replaced}`
        }
    }

}

window.customElements.define('tt-wappen', TTWappen);
